import { FC } from "react";
import cx from "classnames";
import styles from "./discount.module.scss";
import { VehicleSpecialColor } from "@/types/blocks";

interface IDiscount {
  specialColor?: string;
  specialText: string;
  isSRPPage?: boolean;
}

const Discount: FC<IDiscount> = ({ specialColor, specialText, isSRPPage }) => {
  return (
    <div
      className={cx(styles.hasDiscount, {
        [styles.blue]: specialColor === VehicleSpecialColor.BLUE || !specialColor,
        [styles.red]: specialColor === VehicleSpecialColor.RED,
        [styles.yellow]: specialColor === VehicleSpecialColor.YELLOW,
        [styles.violet]: specialColor === VehicleSpecialColor.VIOLET,
        [styles.orange]: specialColor === VehicleSpecialColor.ORANGE,
        [styles.gold]: specialColor === VehicleSpecialColor.GOLD,
        [styles.stroke_black]: specialColor === VehicleSpecialColor.STROKE_BLACK,
        [styles.stroke_green]: specialColor === VehicleSpecialColor.STROKE_GREEN,
        [styles.stroke_white]: specialColor === VehicleSpecialColor.STROKE_WHITE,
        [styles.isSRPPage]: isSRPPage,
      })}
      title={specialText}
    >
      {specialText}
    </div>
  );
};

export default Discount;
